/*
 * Copyright © 2015-2017 Serenova, LLC. All rights reserved.
 */

/*
 *
 * MessagingContentArea
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

//import ErrorBoundary from './components/ErrorBoundary';
// import AwaitingDispositionSpinner from 'components/AwaitingDispositionSpinner';

import Avatar from './components/Avatar';
import LoadingText from './components/LoadingText';
// import CustomFields from './containers/CustomFields';
import MessageContent from './components/MessageContent';
// import ContentArea from 'containers/ContentArea';
// import { selectAgent } from 'containers/Login/selectors';
// import {
//   selectIsEndWrapupDisabled,
//   selectAwaitingDisposition,
// } from 'containers/AgentDesktop/selectors';
// import { setAwaitingDisposition } from 'containers/AgentDesktop/actions';

// import { selectWrapupBtnTooltipText } from 'containers/ContentAreaTop/selectors';

import moment from 'moment';
// import CustomerIndicator from './components/CustomerIndicator';
// import MessagingTextArea from './MessagingTextArea';
// import { copyChatTranscript } from './actions';
// import { isMessagingInteractionCopied } from './selectors';
import messages from './components/messages';

export class MessagingContentArea extends React.Component {
  constructor(props) {
    super(props);
    this.historyRef = React.createRef();
  }

  styles = {
    messageHistoryItem: {
      marginBottom: '10px',
    },
    systemMessage: {
      fontSize: '16px',
      whiteSpace: 'pre-wrap',
      textAlign: 'center',
      color: '#999',
      display: 'inline-block',
      width: '50%',
      margin: '0 25%',
    },
    systemSilentMessage: {
      fontSize: '16px',
      whiteSpace: 'pre-wrap',
      textAlign: 'center',
      color: '#23cdf4',
      display: 'inline-block',
      width: '50%',
      margin: '0 25%',
    },
    avatarContainer: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: '40px',
      paddingTop: '5px',
    },
    messageContainer: {
      display: 'inline-block',
      width: 'calc(100% - 40px)',
    },
    messageFrom: {
      fontSize: '15px',
      fontWeight: 'bold',
    },
    messagePending: {
      color: '#ccc6c6',
    },
    messageTime: {
      fontSize: '12px',
      marginLeft: '7px',
    },
    messagingContainer: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%',
      width: '100%',
      border: '1px solid #c7c7c7',
      borderRadus: '2px',
    },
    outerContainer: {
      height: '360px',
      padding: '0px 58px 20px 58px',
      // magic, but it cleans up the padding a little
      marginTop: '-20px'
    },
    messageHistory: {
      flex: '1',
      overflowY: 'auto',
      padding: '14px 20px',
    },
  };

  componentDidMount() {
    if (this.historyRef.current) {
      // Pre-scroll the window to where it was before it was unselected
      this.historyRef.current.scroll(0, this.props.lastScrollPosition);
    }
  }

  componentWillUnmount() {
    if (this.historyRef.current) {
      const current = this.historyRef.current;
      // Track scroll position
      this.props.setLastScrollPosition(this.props.original.interactionId, current.scrollTop);
      if (current.scrollHeight <= current.clientHeight) {
        // Handle cases where the window is not filled enough to allow scrolling
        // This prevents the "new message" notification from being constantly on for small message histories
        this.props.onSeenNewestMessage(this.props.original.interactionId);
      }
    }
  }

  render() {
    if (this.props.original?.messageHistory !== undefined) {
      let messageHistory = this.props.original.messageHistory.map((message) => {
        let messageContent;
        if (message.type === 'system') {
          messageContent = <span style={this.styles.systemMessage}>{message.text}</span>;
        } else if (message.type === 'system-silent') {
          messageContent = <span style={this.styles.systemSilentMessage}>{message.text}</span>;
        } else {
          messageContent = (
            <div>
              <div style={this.styles.avatarContainer}>
                <Avatar customerAvatarIndex={message.type === 'agent' ? undefined : 1} />
              </div>
              <div style={this.styles.messageContainer}>
                <span style={this.styles.messageFrom}>
                  {message.from}
                </span>
                {!message.pending && (
                  <span style={this.styles.messageTime}>{moment(message.timestamp).format('LT')}</span>
                )}
                <MessageContent message={message} />
              </div>
            </div>
          );
        }
        return (
          <div key={message.from + message.timestamp} style={this.styles.messageHistoryItem}>
            {messageContent}
          </div>
        );
      });
      return (
        <div style={{ height: '360px', padding: '0px 58px 20px 58px', marginTop: '-20px' }}>
          <div style={this.styles.messagingContainer}>
            <div
              ref={this.historyRef}
              style={this.styles.messageHistory}
              onScroll={({ target }) => {
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#determine_if_an_element_has_been_totally_scrolled
                const isAtBottom = Math.abs(target.scrollHeight - target.clientHeight - target.scrollTop) > 1;
                if (isAtBottom) {
                  this.props.onSeenNewestMessage(this.props.original.interactionId);
                }
              }}>
              {messageHistory}
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

MessagingContentArea.propTypes = {
  isCopied: PropTypes.bool,
  agent: PropTypes.object,
  awaitingDisposition: PropTypes.bool,
  original: PropTypes.any,
  onSeenNewestMessage: PropTypes.func,
  lastScrollPosition: PropTypes.any,
  setLastScrollPosition: PropTypes.func,
};

// const mapStateToProps = (state, props) => ({
//   agentId: selectAgent(state, props).userId,
//   isEndWrapupDisabled: selectIsEndWrapupDisabled(state, props),
//   wrapupBtnTooltipText: selectWrapupBtnTooltipText(state, props),
//   isCopied: isMessagingInteractionCopied(state, props),
//   awaitingDisposition: selectAwaitingDisposition(state, props),
// });

// function mapDispatchToProps(dispatch) {
//   return {
//     copyChatTranscript: (interaction) =>
//       dispatch(copyChatTranscript(interaction)),
//     setAwaitingDisposition: (interactionId) =>
//       dispatch(setAwaitingDisposition(interactionId)),
//     dispatch,
//   };
// }

// export default ErrorBoundary(
//   connect(
//     mapStateToProps,
//     mapDispatchToProps
//   )(Radium(MessagingContentArea))
// );
